const useNotify = () => {
  const toast = useToast();
  const reportStore = useReportStore();

  const handleErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    return 'An error occurred. Please try again later.';
  };

  const errorWithoutLog = (error: unknown): void => {
    const message = handleErrorMessage(error);

    toast.add({
      id: message,
      title: message,
      color: 'rose'
    });
  };

  const error = (error: unknown): void => {
    const message = handleErrorMessage(error);

    reportStore.saveLog({
      message: `[CUSTOMER]: ${message}`
    });

    toast.add({
      title: message,
      color: 'rose'
    });
  };

  const success = (message: string): void => {
    toast.add({
      title: message,
      color: 'green'
    });
  };

  return {
    error,
    success,
    errorWithoutLog
  };
};

export { useNotify };
